import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/Home1.jpg";
import AboutImage from "../../assets/images/Home2.jpg";

import { useNavigate } from "react-router-dom";
import "../../css/pages/homePage.css";

import { ReactComponent as InvestmentsIcon } from "../../assets/icons/Investments.svg";
import { ReactComponent as PensionsIcon } from "../../assets/icons/Pensions.svg";
import { ReactComponent as ProtectionIcon } from "../../assets/icons/Protection.svg";
import { ReactComponent as EquityReleaseIcon } from "../../assets/icons/EquityRelease.svg";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import ContactUsPage from "./ContactUsPage";

const HomePage = () => {
  const navigate = useNavigate();

  const introCards = [
    {
      title: "Solutions",
      text: "Tailored solutions to grow, protect and secure your financial future.",
    },
    {
      title: "Clients",
      text: "Supporting business, personal and family clients at every stage.",
    },
    {
      title: "Location",
      text: "Serving clients across Yorkshire and the North East.",
    },
  ];

  const services = [
    {
      title: "Investments",
      icon: <InvestmentsIcon />,
      path: "/investments",
    },
    {
      title: "Pensions",
      icon: <PensionsIcon />,
      path: "/pensions",
    },
    {
      title: "Protection",
      icon: <ProtectionIcon />,
      path: "/protection",
    },
    {
      title: "Equity Release",
      icon: <EquityReleaseIcon />,
      path: "/equity-release",
    },
  ];

  return (
    <div className="home-page">
      <Hero
        title={`Financial Clarity
Direction & Confidence`}
        subtitle="Wealth Management Solutions"
        backgroundImage={HeroBackground}
        titleAlign="left"
        subtitleAlign="left"
      >
        <div className="hero-column">
          <div className="Content">
            At FG Wealth Advisory, we provide clear, personalised financial
            advice to help you grow, protect and maximise your wealth. By
            understanding your goals, we deliver tailored support across
            pensions, investments and insurance for individuals, families and
            business owners, with a focus on long-term relationships that bring
            confidence, clarity and control over your financial future.
          </div>

          {/* <div className="hero-buttons">
            <SecondaryButton
              onClick={() => navigate("/calculators")}
              text="Calculators"
            />
            <PrimaryButton
              onClick={() => navigate("/contact-us")}
              text="Contact"
            />
          </div> */}
        </div>
      </Hero>

      <section className="home-intro-strip">
        <div className="home-container">
          <div className="intro-grid">
            {introCards.map((card, index) => (
              <div className="intro-card" key={card.title}>
                <h3 className="italic">{card.title}</h3>
                <div className="Content">{card.text}</div>

                {/* <SecondaryButton
                  text="More Info"
                  onClick={() => navigate("/about-us")}
                /> */}

                {index !== introCards.length - 1 && (
                  <div className="intro-divider" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="home-about-section">
        <div className="home-container about-grid">
          <div className="about-content">
            <div className="nav primary">About Us</div>

            <h2 className="secondary">
              FG Wealth <span className="italic-text">Advisory</span>
            </h2>

            <div className="small-divider" />

            <div className="content-semibold primary">
              We provide clear, independent financial advice designed to help
              you make confident decisions about your future.
            </div>

            <div className="content primary">
              Our approach is built on understanding your goals, whether
              personal, family or business, and delivering guidance that fits
              your circumstances. We focus on long-term relationships, offering
              ongoing support across pensions, investments and protection to
              help you stay on track as life changes.
            </div>

            <TertiaryButton
              text="Find Out More"
              onClick={() => navigate("/about-us")}
            />
          </div>

          <div className="about-image-wrap">
            <img src={AboutImage} alt="Family walking outdoors" />
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="home-container">
          <div className="services-heading">
            <div className="nav ">Services</div>

            <h2>
              How <span className="italic-text">We Can Help</span>
            </h2>

            <div className="services-divider" />
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div className="service-card" key={service.title}>
                <div className="service-icon">{service.icon}</div>

                <h3>{service.title}</h3>

                <SecondaryButton
                  text="Find Out More"
                  onClick={() => navigate(service.path)}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="investment-note-section">
        <div className="home-container investment-note body">
          <strong>Please Note:</strong> The value of investments and pensions
          can fall as well as rise and you may get back less than you invested.
        </div>
      </section>
      <ContactUsPage />
    </div>
  );
};

export default HomePage;
